import React from 'react';
import {
  BrowserRouter as Router,
  Route,
  Link
} from 'react-router-dom';
import Termsconditions from './components/Termsconditions';
import OTPVerify from './components/OTPVerify';
import Validate from './components/Validate';
import Expiredlink from './components/Expiredlink';
import Dashboard from './components/Dashboard';
import Managebankaccount from './components/Managebankaccount';
import Logout from './components/Logout';
import Home from './components/Home';
import Timeout from './components/Timeout';
import Lock from './components/Lock';

function App() {
  return (
    <Router>
    <div className="App">
      <Route exact path='/' component={Home}/>
      <Route exact path='/Validate' component={Validate}/>  
      <Route exact path='/Expiredlink' component={Expiredlink}/>    
      <Route exact path='/Termsconditions' component={Termsconditions}/>
      <Route exact path='/OTPVerify' component={OTPVerify}/>
      <Route exact path='/Dashboard' component={Dashboard}/>
      <Route exact path='/Managebankaccount' component={Managebankaccount} />  
      <Route exact path='/Timeout' component={Timeout} />    
      <Route exact path='/Logout' component={Logout} />
      <Route exact path='/Lock' component={Lock} />
    </div>
    </Router>
  );
}

export default App;
